<template>
  <div class="container">
    <button class="close" type="button" @click="hiddenSearch">
      <small>CERRAR</small>
      <span>&times;</span>
    </button>
    <a @click.prevent="scrollTop()" class="m-filters-btn" href="#">
      <i class="fa fa-search"></i>
      <span>Filtros</span>
    </a>
    <div class="filters">
      <div class="title">
        <h2>Buscar Eventos</h2>
        <p>¿Dinos qué evento estás buscando?</p>
      </div>

      <div class="content-filters">
        <div class="filter">
          <div class="filter__name" :class="{hasSelected: customPrice}"
          @click="openFilter('price', true)">
            <span>Precio</span>
            <span v-if="customPrice">
              {{ currency }} {{ filters.price.range[0] }} - {{ filters.price.range[1] }}
            </span>
          </div>
          <div class="filter__content" :class="{open: filters.price.show}">
            <div class="filter__content__heading">
              <button class="close" type="button" @click="hiddenFilters('')">
                &times;
              </button>
              <p>Filtra el precio de los eventos que estás buscando.</p>
            </div>
            <div class="filter__content__body">
              <vue-slider ref="slider" v-model="filters.price.range" :min="priceRange.min" :max="priceRange.max" :tooltip="false"></vue-slider>
              <div class="price-range">
                <span>{{ currency }} {{ filters.price.range[0] }}</span> - <span>{{ currency }} {{ filters.price.range[1] }}</span>
              </div>
            </div>
            <div class="filter__content__footer">
              <button type="button" class="btn fl default" @click="resetPriceRange()">Eliminar filtro</button>
              <button type="button" class="btn primary fr" :disabled="loading" @click="search">Aplicar</button>
            </div>
          </div>
        </div>
        <div class="filter">
          <div class="filter__name" :class="{hasSelected: selectedCategory}"
          @click="openFilter('categories', true)">
            <span v-if="!filters.categories.value">Todas las categorías</span>
            <span v-else>{{ selectedCategory.name }}</span>
          </div>
          <div class="filter__content" :class="{open: filters.categories.show}">
            <div class="filter__content__heading">
              <button class="close" type="button" @click="hiddenFilters('')">
                &times;
              </button>
              <p>Filtra todas las categorías que quieres encontrar hoy.</p>
            </div>
            <div class="filter__content__body">
              <div :class="'category-item' + (item.selected ? ' shadow' : '')" v-for="(item, index) in categories" :key="index" @click="selectCategory(index)">
                <span>{{item.name}}</span>
              </div>
            </div>
            <div class="filter__content__footer">
              <button type="button" class="btn fl default" @click="selectCategory('')">Eliminar filtro</button>
              <button type="button" class="btn primary fr" :disabled="loading" @click="search">Aplicar</button>
            </div>
          </div>
        </div>
        <div class="filter">
          <div class="filter__name" :class="{hasSelected: selectedDateLabel}"
          @click="openFilter('dates', true)">
            <span v-if="!selectedDateLabel">Todas las fechas</span>
            <span v-else>{{ selectedDateLabel }}</span>
          </div>
          <div class="filter__content" :class="{open: filters.dates.show}">
            <div class="filter__content__heading">
              <button class="close" type="button" @click="hiddenFilters('')">
                &times;
              </button>
              <p>Filtra las fechas que quieres visualizar en tu búsqueda.</p>
            </div>
            <div class="filter__content__body">
              <div>
                <div v-for="item in staticDates" :key="item.key" class="date-item"
                :class="{shadow: currentDate.key === item.key}"
                @click="selectedDate(item)">
                  <span>{{ item.label }}</span>
                </div>
              </div>
              <p>Ingresa el rango de fecha que quieres visualizar</p>
              <div class="content-calendar">
                <div class="content-calendar__item">
                  <datepicker v-model="rangeDate.start" :disabled-dates="disabledDatesStar" :highlighted="highlighted"
                  placeholder="Desde" :format="'yyyy-MM-dd'" :language="langPicker" ref="pickerStar"
                  @closed="pickerClose('pickerStar')"></datepicker>
                </div>
                <div class="content-calendar__item right">
                  <datepicker v-model="rangeDate.end" :disabled-dates="disabledDatesEnd" :highlighted="highlighted"
                  placeholder="Hasta" :format="'yyyy-MM-dd'" :language="langPicker" ref="pickerEnd"
                  @closed="pickerClose('pickerEnd')"></datepicker>
                </div>
              </div>
            </div>
            <div class="filter__content__footer">
              <button type="button" class="btn default fl" @click="selectedDate('')">Eliminar filtro</button>
              <button type="button" class="btn primary fr" :disabled="loading" @click="search">Aplicar</button>
            </div>
          </div>
        </div>
      </div>
      <div style="clear: both;"></div>
    </div>
    <div class="input-search">
      <span class="input-search__search">
        <i class="fa fa-search"></i>
      </span>
      <input type="search" v-model="textSearch" @keyup="search">
    </div>

    <div v-if="hasResultsActive" key="results" class="results">
      <div v-if="result.length > 0" key="results-list">
        <div v-for="(item, index) in result" :key="index">
          <event-card :item="item"></event-card>
        </div>
      </div>
      <div v-if="!loading && !result.length" key="notfound" class="text-center">
        <h4 v-show="initSearch" key="initSearch">
          No se encontraron resultados para esta búsqueda!
        </h4>
      </div>
      <div style="clear: both;"></div>
    </div>
    <p v-if="loading" key="loading" class="text-center">
      <i class="fa fa-spinner fa-2x fa-spin"></i>
    </p>
    <div v-if="page > 1 && hasResultsActive" key="seemOre" class="text-center">
      <hr>
      <button type="button" class="btn primary" @click="seeMore()">
        Ver más
      </button>
      <br>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import moment from 'moment'
import 'moment/locale/es.js'
import VueSlider from 'vue-slider-component'
import Datepicker from 'vuejs-datepicker'
import { es } from 'vuejs-datepicker/dist/locale'
import axios from 'axios'
import EventCard from './EventCard'
import ConvertToDate from '../ConvertToDate'

moment.locale('es')

const minPriceFn = () => {
  switch (window.app_country) {
    case 'CO':
    case 'MX':
      return 10000
    default:
      return 0
  }
}

const maxPriceFn = () => {
  switch (window.app_country) {
    case 'CO':
    case 'MX':
      return 10000000
    default:
      return 10000
  }
}

const minPrice = minPriceFn()
const maxPrice = maxPriceFn()

const staticDates = [
  {
    key: 'toDay',
    label: 'Hoy'
  },
  {
    key: 'morning',
    label: 'Mañana'
  },
  {
    key: 'thisWeek',
    label: 'Esta semana'
  },
  {
    key: 'nextWeek',
    label: 'Próxima semana'
  },
  {
    key: 'nextMonth',
    label: 'Próximo mes'
  },
  {
    key: 'weekEnd',
    label: 'Fin de semana'
  },
  {
    key: 'thisMonth',
    label: 'Este mes'
  }
]

export default {
  name: 'Home',
  components: {
    VueSlider,
    Datepicker,
    EventCard
  },
  data () {
    return {
      appCountry: window.app_country,
      priceRange: {
        min: minPrice,
        max: maxPrice
      },
      staticDates,
      loading: false,
      initSearch: false,
      langPicker: es,
      msg: '',
      result: [],
      categories: [
        {
          key: 'conciertos',
          name: 'Conciertos',
          selected: false
        },
        {
          key: 'fiestas',
          name: 'Fiestas',
          selected: false
        }, {
          key: 'teatro',
          name: 'Teatro',
          selected: false
        },
        {
          key: 'charlas y conferencias',
          name: 'Charlas y conferencias',
          selected: false
        },
        {
          key: 'seminarios y conferencias',
          name: 'Seminarios y conferencias',
          selected: false
        },
        {
          key: 'kids',
          name: 'Niños',
          selected: false
        },
        {
          key: 'trip & adventure',
          name: 'Viaje y aventura',
          selected: false
        },
        {
          key: 'sports',
          name: 'Deportes',
          selected: false
        },
        {
          key: 'art & culture',
          name: 'Arte y cultura',
          selected: false
        },
        {
          key: 'food & drinks',
          name: 'Comidas y bebidas',
          selected: false
        },
        {
          key: 'entertainment',
          name: 'Entretenimiento',
          selected: false
        },
        {
          key: 'cursos y talleres',
          name: 'Cursos y talleres',
          selected: false
        },
        {
          key: 'technology',
          name: 'Tecnología',
          selected: false
        },
        {
          key: 'community service',
          name: 'Ayuda social',
          selected: false
        }
      ],
      filters: {
        price: {
          show: true,
          range: [minPrice, maxPrice]
        },
        categories: {
          show: false,
          value: ''
        },
        dates: {
          show: false,
          value: []
        }
      },
      rangeDate: {
        start: '',
        end: ''
      },
      textSearch: '',
      timeout: null,
      currentDate: '',
      page: 1,
      hasResultsActive: true
    }
  },
  mounted () {
    const _self = this
    _self.openFilter('price')

    document.body.addEventListener('keyup', e => {
      if (e.keyCode === 27) {
        _self.hiddenSearch()
      }
    })
  },
  computed: {
    currency () {
      return this.appCountry === 'PE' ? 'S/ ' : '$'
    },
    dateRange () {
      const arr = []
      const { start, end } = this.rangeDate
      const startD = start ? ConvertToDate.format(start, true) : ''
      const endD = end ? ConvertToDate.format(end) : ''
      arr.push(startD)
      arr.push(endD)
      return arr
    },
    disabledDatesStar () {
      return {
        to: new Date()
      }
    },
    disabledDatesEnd () {
      const start = new Date(this.rangeDate.start)
      const next = new Date()
      next.setDate(start.getDate() + 1)
      return {
        to: new Date(this.rangeDate.start)
      }
    },
    highlighted () {
      const { start, end } = this.rangeDate
      if (!start) return {}
      const endDate = end ? new Date(end) : new Date(start)
      return {
        from: new Date(start),
        to: endDate
      }
    },
    selectedCategory () {
      return this.categories.find((el) => el.selected)
    },
    selectedDateLabel () {
      if (this.currentDate.key) {
        return this.currentDate.label
      }
      if (this.filters.dates.value.length > 1) {
        const { start, end } = this.rangeDate
        const startD = start ? moment(start).format('DD [de] MMM') : ''
        const endD = end ? moment(end).format('DD [de] MMM') : ''
        return startD && endD ? `${startD} - ${endD}` : ''
      }
      return ''
    },
    customPrice () {
      return this.filters.price.range[0] > minPrice || this.filters.price.range[1] < maxPrice
    }
  },
  methods: {
    scrollTop () {
      $('#app-search').animate({ scrollTop: 0 }, 600)
    },
    resetPriceRange () {
      this.filters.price.range = [0, maxPrice]
    },
    pickerClose (picker) {
      this.currentDate = ''
      this.filters.dates.value = this.dateRange
      if (picker === 'pickerStar') {
        const sd = { ...this.rangeDate }
        this.rangeDate.end = sd.start
        const endInput = $(this.$refs.pickerEnd.$el).find('input')[0]
        endInput.focus()
        endInput.click()
      }
    },
    hiddenSearch () {
      this.$parent.closeFilters()
    },
    openFilter (filter, status) {
      this.hiddenFilters(filter)
      this.filters[filter].show = status
    },
    hiddenFilters (filterExclude) {
      for (const item in this.filters) {
        if (item !== filterExclude) {
          this.filters[item].show = false
        }
      }
    },
    selectCategory (index) {
      this.categories.forEach((item, i) => {
        if (i !== index) {
          item.selected = false
        }
      })
      if (index !== '') {
        this.categories[index].selected = !this.categories[index].selected
        this.filters.categories.value = this.categories[index].selected ? this.categories[index].key : ''
      } else {
        this.filters.categories.value = ''
      }
    },
    selectedDate (fn) {
      let date = []
      let key = fn ? fn.key : ''
      this.rangeDate = {
        start: '',
        end: ''
      }

      switch (key) {
        case 'toDay':
          date = ConvertToDate.toDay()
          break

        case 'morning':
          date = ConvertToDate.morning()
          break

        case 'thisWeek':
          date = ConvertToDate.thisWeek()
          break

        case 'nextWeek':
          date = ConvertToDate.nextWeek()
          break

        case 'thisMonth':
          date = ConvertToDate.thisMonth()
          break

        case 'nextMonth':
          date = ConvertToDate.nextMonth()
          break

        case 'weekEnd':
          date = ConvertToDate.weekEnd()
          break

        default:
          date = []
          break
      }

      if (key === this.currentDate.key) {
        date = []
        this.currentDate = ''
      } else {
        this.currentDate = fn
      }

      this.filters.dates.value = date
    },
    search () {
      const _self = this
      this.hasResultsActive = false
      this.hiddenFilters()
      clearTimeout(_self.timeout)
      _self.timeout = setTimeout(function () {
        _self.searchProcess()
      }, 1000)
    },
    searchProcess (seeMore) {
      const _self = this
      if (!this.page && seeMore) return
      this.loading = true
      this.initSearch = true
      const data = {
        country: this.appCountry,
        text: this.textSearch,
        filters: this.filters,
        page: seeMore ? this.page : 1
      }

      axios.post(this.apiUrl + '/event-search', data)
        .then(response => {
          this.loading = false
          this.hasResultsActive = true
          const res = response.data
          if (res.status) {
            _self.result = seeMore ? _self.result.concat(res.data.hits) : res.data.hits
            _self.page = res.data.nextPage
            _self.setFirstType()
          }
        })
        .catch(e => {
          this.loading = false
          this.hasResultsActive = true
          console.log(e)
        })
    },

    getType (types) {
      let type = {
        name: '',
        type: '',
        price: null,
        enabled: false
      }
      for (let i = 0; i < types.length; i++) {
        if (
          (parseFloat(types[i].price) < type.price || i === 0 || type.price === null) && types[i].enabled && (types[i].visibility === 'ALL' || types[i].visibility === 'ONLINE') && (types[i].url === '' || types[i].url === null)) {
          type = types[i]
        }
      }

      return type
    },

    setFirstType () {
      for (let i = 0; i < this.result.length; i++) {
        this.result[i]._source.firstType = this.getType(this.result[i]._source.types)
      }
    },
    seeMore () {
      this.hasResultsActive = true
      this.searchProcess(true)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Home.vue